import { render, staticRenderFns } from "./ModalChangeLog.vue?vue&type=template&id=1b38318c&scoped=true"
import script from "./ModalChangeLog.ts?vue&type=script&lang=ts&external"
export * from "./ModalChangeLog.ts?vue&type=script&lang=ts&external"
import style0 from "./ModalChangeLog.vue?vue&type=style&index=0&id=1b38318c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b38318c",
  null
  
)

export default component.exports